export const whatItMeanListing = [
	{
		icon: '☝️',
		subtitle: 'whatItMeanData_subtitle1',
	},
	{
		icon: '💁‍♀️',
		subtitle: 'whatItMeanData_subtitle2',
	},
	{
		icon: '🤘',
		subtitle: 'whatItMeanData_subtitle3',
	},
];
